import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const FenceInstallation = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my fence installation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps fence installation businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for fence installation businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most fence installation businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my fence installation business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like fence installation. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Fence Installation - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Fence Installation CRM", url: "/industries/fence-installation" }
  ];

  const industryData = {
    name: 'Fence Installation',
    title: 'Stop Losing Estimate Leads & Book Projects Months Ahead',
    subtitle: 'Automate estimate follow-ups, showcase your work, and convert more quotes to signed contracts',
    icon: '🚧',
    challenges: [
      'Estimates go cold while working on jobs',
      'Hard to showcase quality of previous work',
      'Weather delays cause scheduling chaos',
      'HOA approval process slows projects',
      'Customers ghost after initial quote'
    ],
    solutions: [
      'Automated estimate follow-up sequences',
      'Digital portfolio with before/after',
      'Weather-based rescheduling alerts',
      'HOA approval tracking system',
      'Multi-touchpoint nurture campaigns'
    ],
    features: [
      'Customer CRM with project details',
      'Estimate tracking and follow-up',
      'Photo gallery management',
      'Project scheduling',
      'HOA approval documentation',
      'Material calculator',
      'Payment milestone tracking',
      'Review automation'
    ],
    results: [
      '55% more estimates convert',
      'Book 8-12 weeks in advance',
      '40% increase via referrals',
      '£7.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Fence Installation UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for fence installation businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for fence installation UK, fence installation business software, fence installation customer management, fence installation lead generation UK"
        url="/industries/fence-installation"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default FenceInstallation;